import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormCardLayout } from '@main/components';
import Button from '@mui/material/Button';
import { showMessage } from 'app/store/core/messageSlice';
import { useRequest } from '@main/hooks';
import { useSimpleAlert } from '@main/hooks/useSimpleAlert';
import { laravelSynchronize, laravelSeeds, startup } from 'src/app/api/setup';
import { delayFunction } from 'src/app/utils/timer';
import { arraysContainSameValues } from 'src/app/utils/conversors';
import { Divider } from '@mui/material';
import { ProgressStep } from '../Components';
import { StepperContext } from '../Context/SetupContext';
import { checkpointsInitialize, getCompletedCheckpoints } from '../Checkpoints/checkpoints';

export const Initialize = ({ onSuccess = () => {} }) => {
  const Dispatch = useDispatch();
  const openAlert = useSimpleAlert();
  const { addLogs, companyId, companyName, currentCheckpoint } = useContext(StepperContext);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  // -------- Obteniendo checkpoints
  const handleUpdateSteps = (incomingStep) => {
    const stepIsThere = completedSteps.includes(incomingStep);
    if (stepIsThere) return;
    setCompletedSteps((current) => [...current, incomingStep]);
  };

  useEffect(() => {
    if (currentCheckpoint === undefined || currentCheckpoint === null) return;
    const isThere = checkpointsInitialize.includes(currentCheckpoint);
    if (!isThere) return;
    console.log(currentCheckpoint);
    const checkpointsList = getCompletedCheckpoints(currentCheckpoint);
    if (checkpointsList !== undefined) {
      console.log(checkpointsList);
      setCompletedSteps(checkpointsList);
    }
  }, [currentCheckpoint]);

  useEffect(() => {
    console.log('completed steps', completedSteps);
    if (completedSteps === undefined) return;
    console.log('has changed completedSteps');
    const isStepsComplete = arraysContainSameValues(completedSteps, checkpointsInitialize);
    console.log('Esta completo? ', isStepsComplete);
    setIsCompleted(isStepsComplete);
  }, [completedSteps]);

  useEffect(() => {
    if (isCompleted === undefined) return;
    onSuccess(true);
  }, [isCompleted]);

  useEffect(() => {
    return () => {
      setCompletedSteps([]);
    };
  }, []);

  // -------- Definicion de requests
  const {
    makeRequest: tryLaravelSynchronize,
    isLoading: isLoadingLaravelSynchronize,
    status: statusLaravelSynchronize,
    logger: loggerLaravelSynchronize,
  } = useRequest(laravelSynchronize);

  const {
    makeRequest: tryLaravelSeeds,
    isLoading: isLoadingLaravelSeeds,
    status: statusLaravelSeeds,
    logger: loggerLaravelSeeds,
  } = useRequest(laravelSeeds);

  const {
    makeRequest: tryStartUp,
    isLoading: isLoadingStartUp,
    status: statusStartUp,
    logger: loggerStartUp,
  } = useRequest(startup);

  // ------ Listeners de logs ------
  useEffect(() => {
    if (loggerLaravelSynchronize === undefined) return;
    addLogs(loggerLaravelSynchronize);
  }, [loggerLaravelSynchronize]);

  useEffect(() => {
    if (loggerLaravelSeeds === undefined) return;
    addLogs(loggerLaravelSeeds);
  }, [loggerLaravelSeeds]);

  useEffect(() => {
    if (loggerStartUp === undefined) return;
    addLogs(loggerStartUp);
  }, [loggerStartUp]);

  const tryStepsWizard = async () => {
    setDisableButton(true);
    if (companyId === undefined) {
      Dispatch(
        showMessage({
          message: 'No se encontro el ID de compania',
        })
      );
      return;
    }
    try {
      // ---- Sincronizar Laravel
      const step10ok = await delayFunction(
        completedSteps.includes(checkpointsInitialize[0]),
        tryLaravelSynchronize,
        companyId
      );
      if (!step10ok) return;
      handleUpdateSteps(checkpointsInitialize[0]);
      console.log('Step okii');

      // ---- Seeds Laravel
      const step11ok = await delayFunction(
        completedSteps.includes(checkpointsInitialize[1]),
        tryLaravelSeeds,
        companyId
      );
      if (!step11ok) return;
      handleUpdateSteps(checkpointsInitialize[1]);
      console.log('Step okii');

      // ---- Inicializar
      const step12ok = await delayFunction(
        completedSteps.includes(checkpointsInitialize[2]),
        tryStartUp,
        companyId
      );
      if (!step12ok) return;
      handleUpdateSteps(checkpointsInitialize[2]);
      console.log('Step okii');
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButton(false);
    }
  };

  const handleBypassStep = (stepName) => {
    if (typeof stepName !== 'string' || stepName === undefined) return;
    openAlert({
      title: 'Atencion',
      description: 'Esta seguro que desea omitir este paso?',
    }).then((userResponseOk) => {
      if (!userResponseOk) return;
      handleUpdateSteps(stepName);
      Dispatch(
        showMessage({
          message: `El paso ${stepName} ha sido omitido`,
        })
      );
    });
  };

  useEffect(() => {
    console.log(companyId);
  }, [companyId]);

  const handleManualRetry = (reqToRetry = () => new Promise(), ...args) => {
    reqToRetry(...args)
      .then((isOk) => {
        console.log(isOk);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <FormCardLayout.FullColum>
        <div className="mt-24 flex flex-row w-full justify-center items-center">
          <Button
            aria-label="Comenzar"
            onClick={() => tryStepsWizard()}
            variant="contained"
            className="w-full md:w-auto"
            color="primary"
            disabled={disableButton || isCompleted}
          >
            Comenzar
          </Button>
        </div>
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <Divider variant="middle" />
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <div className="px-32 flex flex-col w-full justify-start items-start">
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsInitialize[0])}
            status={
              completedSteps.includes(checkpointsInitialize[0])
                ? 'SUCCESS'
                : statusLaravelSynchronize
            }
            isLoading={isLoadingLaravelSynchronize}
            stepName="Sincronizando Laravel"
            disableOptions={completedSteps.includes(checkpointsInitialize[0])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsInitialize[1])}
            status={
              completedSteps.includes(checkpointsInitialize[1]) ? 'SUCCESS' : statusLaravelSeeds
            }
            isLoading={isLoadingLaravelSeeds}
            stepName="Cargando datos iniciales (tiempo estimado 2-4 minutos)"
            disableOptions={completedSteps.includes(checkpointsInitialize[1])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsInitialize[2])}
            status={
              completedSteps.includes(checkpointsInitialize[2]) ? 'SUCCESS' : statusLaravelSeeds
            }
            isLoading={isLoadingLaravelSeeds}
            stepName="Inicializando"
            disableOptions={completedSteps.includes(checkpointsInitialize[2])}
          />
        </div>
      </FormCardLayout.FullColum>
    </>
  );
};
